/* Project Import will be here */
import { post, IRequest } from "services/index";
/* Project Import will be here */

export const getEarnedPointsApi = () => {
    const request: IRequest = { subUrl: `/Loyalty/GetEarningLedger` };
    return post(request);
};

export const getClubEnrollmentInfoApi = () => {
    const request: IRequest = { subUrl: `/Loyalty/GetClubEnrollmentInfo` };
    return post(request);
};

export const getExistingClubEnrollmentStatusApi = () => {
    const request: IRequest = { subUrl: `/Loyalty/CheckEnrollmentExists` };
    return post(request);
};

export const getClubEnrollmentCalcApi = (data) => {
    const request: IRequest = { subUrl: `/Loyalty/GetClubEnrollmentCalc`, data };
    return post(request);
};

export const saveClubEnrollmentApi = (data) => {
    const request: IRequest = { subUrl: `/Loyalty/SubmitClubEnrollment`, data };
    return post(request);
};